var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4667 5.37195L12.4671 5.37233C12.5261 5.42207 12.5317 5.46228 12.5312 5.48216C12.5307 5.50559 12.5192 5.55646 12.4511 5.61409C12.2876 5.75191 12.0583 5.74377 11.934 5.6387L11.691 5.43331L10.9196 4.78143V5.79133V10.3125C10.9196 10.3451 10.9053 10.3921 10.8477 10.4407C10.7891 10.4903 10.6942 10.5312 10.5749 10.5312H7.7898V8.25V7.78125H7.32105H5.69412H5.22537V8.25V10.5312H2.44025C2.32095 10.5312 2.2261 10.4903 2.16747 10.4407C2.1099 10.3921 2.09553 10.3451 2.09553 10.3125V5.77792V4.76755L1.32407 5.42002L1.0464 5.65486C0.9331 5.75062 0.725475 5.76425 0.54935 5.61502L0.5489 5.61464C0.480641 5.55695 0.469313 5.5062 0.468775 5.48278C0.468313 5.4627 0.474062 5.42199 0.53332 5.37171C0.533376 5.37167 0.533432 5.37162 0.533488 5.37157L6.22731 0.559452C6.29142 0.505271 6.38858 0.46875 6.49986 0.46875C6.61113 0.46875 6.70829 0.505271 6.7724 0.559452L12.4667 5.37195Z",
    fill: "#E0DEDE",
    stroke: "#E0DEDE",
    strokeWidth: 0.9375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/house-icon.cce06ea393d7c44edea6f6c09003f1b0.svg";
export { ForwardRef as ReactComponent };